"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MONTHS_IN_YEAR = 12;
/** How much months to place in row on calendar page. */
exports.MONTH_PAGE_WIDTH = 3;



//////////////////
// WEBPACK FOOTER
// ./node_modules/semantic-ui-calendar-react/dist/commonjs/pickers/monthPicker/const.js
// module id = 351
// module chunks = 0